<script setup lang="ts">
import { useHead } from "#imports";

useHead({ title: 'Rana Marketplace',
  link: [
        { rel: 'manifest', href: '/manifest.webmanifest' }
      ],
  meta: [
    { name: 'description', content: 'Marketplace of AI models, Progressive Web Applications (PWAs), compute and other resources.' },
    { property: 'og:title', content: 'Rana Marketplace - Just ask Rana' }
  ]
})
</script>

<template>
  <NuxtLayout>
    <Suspense>
    <NuxtPage />
    </Suspense>
  </NuxtLayout>
</template>
